import type { AiAppCenterModule } from '../types'

export const loveModule: AiAppCenterModule = {
  key: 'love',
  label: 'AI婚恋社交',
  desc: '用户管理 / 智能匹配 / 红娘服务 / 婚恋运营',
  path: '/love',
  homePath: '/love/dashboard',
  icon: 'ep:user-filled',
  color: '#ec4899',
  aliases: ['婚恋设计', '婚恋社交', 'AI 婚恋社交']
}
